import React from 'react';

const items = ['Basketball', 'Fitness', 'Strength', 'Mindset', 'Discipline', 'Accountability', 'Next Level'];

export const MarqueeStrip = () => {
  const row = [...items, ...items];
  return (
    <div data-testid="marquee-strip" className="relative bg-black border-y border-neutral-900 py-5 overflow-hidden">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display uppercase text-2xl text-neutral-700 px-6">{item}</span>
            <span className="w-2 h-2 rounded-full bg-gray-500" />
          </span>
        ))}
      </div>
    </div>
  );
};
